import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { WmProgressIndicator, WmProgressMonitor, WmProgressSlice } from "@watermarkinsights/ripple-react";
import "../../../common/Insights.scss";
import translate from "../../../../i18n/translate";
import { useIntl } from "react-intl";
import { popover } from "./CoursesChart";
import ApiError from "src/features/common/elements/ApiError";
export default function OrganizationChart(_a) {
    var organizationData = _a.organizationData;
    return (_jsx(React.Fragment, { children: _jsxs("div", { children: [_jsx("h3", { className: "title organization-progress", children: translate("app.orgProgressCard.orgProgress") }), organizationData.organizationApiError ? (_jsx(ApiError, { containerClasses: "api-error" })) : (_jsxs(_Fragment, { children: [_jsx("p", { className: "org totals", children: translate("app.orgProgressCard.orgTotal", {
                                totalOrgs: organizationData.totalOrgs
                            }) }), _jsx("div", { id: "org-charts-html", children: _jsx(OrgChart, { organizationData: organizationData }) })] }))] }) }));
}
var OrgChart = function (_a) {
    var organizationData = _a.organizationData;
    var added = useIntl().formatMessage({
        id: "app.drilldown.added"
    });
    var notAdded = useIntl().formatMessage({
        id: "app.drilldown.notAdded"
    });
    var created = useIntl().formatMessage({
        id: "app.drilldown.created"
    });
    var notCreated = useIntl().formatMessage({
        id: "app.drilldown.notCreated"
    });
    var mapped = useIntl().formatMessage({
        id: "app.drilldown.mapped"
    });
    var notMapped = useIntl().formatMessage({
        id: "app.drilldown.notMapped"
    });
    var organizationsWithoutILO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithoutILO"
    });
    var organizationsWithILO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithILO"
    });
    var organizationsWithoutSO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithoutSO"
    });
    var organizationsWithSO = useIntl().formatMessage({
        id: "app.orgProgressCard.organizationsWithSO"
    });
    var orgWithoutLO = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithoutLO"
    });
    var orgWithLO = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithLO"
    });
    var ILOMapped = useIntl().formatMessage({
        id: "app.orgProgressCard.ILOMapped"
    });
    var successOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.successOutcomes"
    });
    var learningOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.learningOutcomes"
    });
    var orgWithoutMission = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithoutMission"
    });
    var orgWithMission = useIntl().formatMessage({
        id: "app.orgProgressCard.orgWithMission"
    });
    var missionStatement = useIntl().formatMessage({
        id: "app.orgProgressCard.missionStatement"
    });
    return (_jsxs(WmProgressMonitor, { id: "organization-progress", "print-mode": true, "bar-labels-width": "5rem", children: [_jsxs(WmProgressIndicator, { label: missionStatement, children: [_jsx(WmProgressSlice, { legend: added, amount: organizationData.organizationMissionComplete.toString(), popoverTitle: popover(organizationData.organizationMissionComplete, organizationData.totalOrgs), popoverText: orgWithMission }), _jsx(WmProgressSlice, { legend: notAdded, amount: organizationData.organizationMissionIncomplete.toString(), popoverTitle: popover(organizationData.organizationMissionIncomplete, organizationData.totalOrgs), popoverText: orgWithoutMission })] }), _jsxs(WmProgressIndicator, { label: learningOutcomes, children: [_jsx(WmProgressSlice, { legend: created, amount: organizationData.learningOutcomes.toString(), popoverTitle: popover(organizationData.learningOutcomes, organizationData.totalOrgs), popoverText: orgWithLO }), _jsx(WmProgressSlice, { legend: notCreated, amount: organizationData.learningOutcomesIncomplete.toString(), popoverTitle: popover(organizationData.learningOutcomesIncomplete, organizationData.totalOrgs), popoverText: orgWithoutLO })] }), _jsxs(WmProgressIndicator, { label: successOutcomes, children: [_jsx(WmProgressSlice, { legend: created, amount: organizationData.otherOutcomes.toString(), popoverTitle: popover(organizationData.otherOutcomes, organizationData.totalOrgs), popoverText: organizationsWithSO }), _jsx(WmProgressSlice, { legend: notCreated, amount: organizationData.otherOutcomesIncomplete.toString(), popoverTitle: popover(organizationData.otherOutcomesIncomplete, organizationData.totalOrgs), popoverText: organizationsWithoutSO })] }), _jsxs(WmProgressIndicator, { label: ILOMapped, children: [_jsx(WmProgressSlice, { legend: mapped, amount: organizationData.iloMappings.toString(), popoverTitle: popover(organizationData.iloMappings, organizationData.totalOrgs), popoverText: organizationsWithILO }), _jsx(WmProgressSlice, { legend: notMapped, popoverTitle: popover(organizationData.iloMappingsIncomplete, organizationData.totalOrgs), popoverText: organizationsWithoutILO, amount: organizationData.iloMappingsIncomplete.toString() })] })] }));
};
